const Paths = {
    productListAd: '/banners/product-list-ads',
    productListAdCreate: '/banners/product-list-ads/create',
};

export default Paths;



// WEBPACK FOOTER //
// ./src/modules/ProductListAd/paths.ts